const LONGEST_TRANSITION_DURATION = 350; // ms

export default function enableTransitions() {
	setTimeout(() => {
		document.body.classList.remove('is-transition-disabled');
	}, LONGEST_TRANSITION_DURATION);
}
